import { Component, Input } from '@angular/core';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { CatalogItem } from 'src/app/models/catalog-item.model';

@Component({
  selector: 'app-catalog-product-description',
  templateUrl: './catalog-product-description.component.html',
  styleUrls: ['./catalog-product-description.component.scss'],
  imports: [AgrI18nSharedModule],
})
export class CatalogProductDescriptionComponent {
  @Input() catalogItem: CatalogItem;
  @Input() disabled: boolean;
}
